import React from 'react'

import {format} from 'd3-format'
import {timeFormat} from 'd3-time-format'

import {Chart} from 'react-stockcharts'
import {CandlestickSeries} from 'react-stockcharts/lib/series'
import {XAxis, YAxis} from 'react-stockcharts/lib/axes'
import {MouseCoordinateX, MouseCoordinateY, EdgeIndicator} from 'react-stockcharts/lib/coordinates'
import {plotDataLengthBarWidth} from 'react-stockcharts/lib/utils'
import {Brush} from 'react-stockcharts/lib/interactive'

import {OHLCTooltip} from './OHLCTooltip'
import {Indicators} from './Indicators'

export const Candlestick = ({gridWidth, indicators, compare, showModal, marginTop, frequency, brushEnabled, handleBrush}) => {
  const height = 308
  const yGrid = {
    innerTickSize: -1 * gridWidth,
    tickStrokeDasharray: 'Solid',
    tickStrokeOpacity: 0.2,
    tickStrokeWidth: 1
  }
  const xGrid = {
    innerTickSize: -1 * height,
    tickStrokeDasharray: 'Solid',
    tickStrokeOpacity: 0.2,
    tickStrokeWidth: 1
  }

  let yExtents = [d => [d.high, d.low]]
  if (compare.ticker) {
    yExtents.push(d => d[compare.ticker.toLowerCase()])
  }
  if (indicators.length) {
    yExtents.push(d => indicators.map(ind => d[ind.syntax]))
  }

  const bbIndex = indicators.findIndex(ind => ind.syntax === 'bb')
  if (bbIndex > -1 && bbIndex < indicators.length - 1) {
    const temp = indicators.splice(bbIndex, 1)
    indicators = indicators.concat(temp)
  }
  if (compare.ticker) {
    indicators.unshift(compare)
  }

  return(
    <Chart
      id='candlestick'
      yExtents={yExtents}
      height={height}
    >
      <XAxis
        axisAt='bottom'
        orient='bottom'
        strokeWidth={1.5}
        stroke='rgb(0,0,0,0.5)'
        fontFamily='GothamHTF'
        tickStroke='#d3d3d3'
        tickPadding={12}
        fontSize={12}
        {...xGrid}
      />
      <YAxis
        axisAt='right'
        orient='right'
        ticks={10}
        fontFamily='GothamHTF'
        tickStroke='#d3d3d3'
        tickFormat={d => Math.abs(d) > 1 ? format('.4s')(d) : format('.4r')(d)}
        fontSize={12}
        {...yGrid}
      />

      <EdgeIndicator
        itemType='last'
        orient='right'
        edgeAt='right'
        yAccessor={d => d.close}
        fill={d => d.close > d.open ? '#6BA583' : '#FF0000'}
        fontFamily='GothamHTF'
        rectWidth={65}
        arrowWidth={10}
        displayFormat={d => Math.abs(d) > 1 ? format('.4s')(d) : format('.4r')(d)}
      />
      <MouseCoordinateX
        at='bottom'
        orient='bottom'
        rectWidth={frequency != 'hourly' ? 80 : 120}
        displayFormat={frequency != 'hourly' ? timeFormat('%m/%d/%Y') : timeFormat('%I %p %m/%d/%Y')}
        fontFamily='GothamHTF'
      />
      <MouseCoordinateY
        at='right'
        orient='right'
        displayFormat={d => Math.abs(d) > 1 ? format('.4s')(d) : format('.4r')(d)}
        fontFamily='GothamHTF'
        rectWidth={65}
        arrowWidth={10}
      />

      <CandlestickSeries
        width={plotDataLengthBarWidth}
        widthRatio={0.5}
        stroke={d => d.close > d.open ? '#6BA583' : '#FF0000'}
        wickStroke={d => d.close > d.open ? '#6BA583' : '#FF0000'}
      />

      {brushEnabled && //relying on just enabled prop causes a bug with subsequent zooms
        <Brush
          enabled={brushEnabled}
          type='2D'
          onBrush={handleBrush}
        />
      }

      {OHLCTooltip({
        origin:{x: -55, y: -marginTop + 36}
      })}

      {Indicators({
        indicators, showModal, gridWidth, yGrid, marginTop
      })}
    </Chart>
  )
}
